import { exchangeCode, exchangeCodeViaProxy, type GoogleTokens } from "@app/storage";
import { detectPlatform } from "../../platform.js";
import type { OAuthResult } from "./index.js";

/** Web exchanges the auth code through OUR backend (Web OAuth clients are
 *  confidential — the secret can't ship in the bundle); Android uses a public
 *  PKCE client and exchanges directly with Google. */
export const usesProxy = (): boolean => detectPlatform() !== "capacitor";

/** Trade an authorization code (from {@link runOAuthFlow}) for Google tokens,
 *  routed per platform. `serverUrl` is only used on the proxy (web) path. Shared
 *  by both Calendar connect and the identity sign-in flows. */
export function exchangeAuthCode(args: {
  serverUrl: string;
  clientId: string;
  result: OAuthResult;
}): Promise<GoogleTokens> {
  const { code, verifier, redirectUri } = args.result;
  if (usesProxy()) {
    return exchangeCodeViaProxy(args.serverUrl, { code, verifier, redirectUri });
  }
  return exchangeCode({ code, verifier, redirectUri, clientId: args.clientId });
}
